/*
Copyright (c) 2015, salesforce.com, inc. All rights reserved.
Copyright (c) 2018, Picsa Advisory Services (Pty) Ltd. All rights reserved.

Redistribution and use in source and binary forms, with or without modification, are permitted provided that the following conditions are met:
Redistributions of source code must retain the above copyright notice, this list of conditions and the following disclaimer.
Redistributions in binary form must reproduce the above copyright notice, this list of conditions and the following disclaimer in the documentation and/or other materials provided with the distribution.
Neither the name of salesforce.com, inc. nor the names of its contributors may be used to endorse or promote products derived from this software without specific prior written permission.

THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS 'AS IS' AND ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED. IN NO EVENT SHALL THE COPYRIGHT OWNER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES LOSS OF USE, DATA, OR PROFITS OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
*/

import React from 'react'
import PropTypes from 'prop-types'
import { Query } from 'react-apollo'
import { markdown } from 'markdown'

import {
  SvgIcon,
  Spinner,
  Warning,
  FileViewer
} from '../'

import {
  QUERY_EMAIL
} from '../../queries'

export const Email = ({ id, className }) => (
  <Query query={QUERY_EMAIL} variables={{ id }} >
    {({ loading, error, data }) => {
      if (loading) {
        return <Spinner className='slds-is-relative' size='small' />
      }

      if (error || data.email === null) {
        return (
          <Warning className={className ? className : ''}>
            Error loading email.
          </Warning>
        )
      }

      let email = data.email
      return (
        <EmailDisplay
          subject={email.subject}
          fromAddr={email.fromAddr}
          toAddrs={email.toAddrs}
          textBody={email.textBody}
          attachments={email.attachments}
          className={className}
        />
      )
    }}
  </Query>
)

Email.propTypes = {
  id: PropTypes.string,
  className: PropTypes.string
}

export const EmailDisplay = ({ subject, fromAddr, toAddrs, textBody, htmlBody, attachments, className }) => {
  let messageHasTextBody = textBody
  let messageHasAttachments = attachments.length > 0

  return (
    <div className={`u-bg-color-white ${className ? className : ''}`}>
      <div className='u-font-size-larger slds-m-bottom_medium'>
        {subject}
      </div>
      <div className='slds-grid slds-m-bottom_large'>
        <div className='slds-m-right_medium slds-text-color_weak'>
          From:
          <br />
          To:
        </div>
        <div>
          {fromAddr}
          <br />
          {toAddrs}
        </div>
      </div>
      {messageHasTextBody
        ? <div
            className='slds-text-longform slds-border_bottom slds-border_top slds-p-top_small slds-p-bottom_small'
            dangerouslySetInnerHTML={{ __html: markdown.toHTML(textBody) }}
          />
        : <div dangerouslySetInnerHTML={{ __html: htmlBody }} />
      }
      {messageHasAttachments &&
        <div className='slds-m-top_medium'>
          <div className='u-font-size-larger'>
            <SvgIcon
              variant='utility'
              symbol='attach'
              size='small'
              className='slds-m-right_small'
            />
            Attachments:
          </div>
          <FileViewer
            inline={true}  // FileViewer is used 'inline' when viewing email attachments
            files={attachments}
            // onClick={() => console.log('view')}
          />
        </div>
      }
    </div>
  )
}

EmailDisplay.propTypes = {
  subject: PropTypes.string,
  fromAddr: PropTypes.string,
  toAddrs: PropTypes.arrayOf(PropTypes.string),
  textBody: PropTypes.string,
  attachments: PropTypes.array,
  className: PropTypes.string
}



// WEBPACK FOOTER //
// ./src/components/email/index.js